/**
 * @typedef {import('./types').Match} Match
 */

/**
 * The winner of a match as reported by Opta — usually one of
 * `'home' | 'away' | 'draw'`. Returns `undefined` when the data is not yet
 * available (e.g. the match hasn't been played).
 *
 * @param {Match} [match]
 * @returns {string | undefined}
 */
const getWinner = (match) => match?.liveData?.matchDetails?.winner;

export default getWinner;
